import { Slide } from "@jelly/lesson";

import { task as task02 } from "../../../../../task/course-03/lesson-09/task-02";

const task: Slide = {
  titleHtml: "What is the procedure of simulation?",
  description: "Drag and drop the steps into the correct order.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task02.id,
        },
      },
    },
  },
};

export default task;
